import React from 'react'
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Button,
  Backdrop,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const QUOTE_KEYS = ['transWriteLife', 'transClarify', 'transDirection', 'transNoNeedKnowAll'] // LAP-733 (GE022)

const GlassDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    padding: theme.spacing(4),
    maxWidth: '600px',
    textAlign: 'center',
  },
}))

const TransitionScreen = ({ open, onStart }) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [quoteKey, setQuoteKey] = React.useState('')

  React.useEffect(() => {
    // Select random quote on mount
    const randomKey = QUOTE_KEYS[Math.floor(Math.random() * QUOTE_KEYS.length)]
    setQuoteKey(randomKey)
  }, [])

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backgroundImage: 'url(/image%20full.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
      }}
    >
      <GlassDialog open={open} maxWidth="sm" fullWidth>
        <DialogContent>
          <Typography
            variant="h4"
            sx={{
              color: 'white',
              mb: 3,
              fontWeight: 600,
              fontSize: { xs: '1.8rem', md: '2.2rem' },
            }}
          >
            {t('roadmap.transLifeWorth')}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: 'rgba(255, 255, 255, 0.95)',
              mb: 4,
              fontStyle: 'italic',
              minHeight: '60px',
              fontWeight: 400,
              fontSize: { xs: '1.1rem', md: '1.3rem' },
              lineHeight: 1.6,
            }}
          >
            « {quoteKey ? t('roadmap.' + quoteKey) : ''} »
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255, 255, 255, 0.85)',
              mb: 4,
              lineHeight: 1.75,
              fontSize: { xs: '1rem', md: '1.1rem' },
            }}
          >
            {t('roadmap.transTakeMoment')}
            <br />
            {t('roadmap.transJustIdeas')}{' '}{t('roadmap.transLaterAdjust')}
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={onStart}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {t('roadmap.transBegin')}
          </Button>
        </DialogContent>
      </GlassDialog>
    </Backdrop>
  )
}

export default TransitionScreen

